export default __webpack_public_path__ + "static/media/GatcoLogoBlue.4e7e298b.svg";